// columns: [{ title, value: (row) => any }]
const toCsv = (rows, columns) => {
  const cell = (value) => {
    const text = value == null ? "" : String(value);
    return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };
  return [
    columns.map((column) => cell(column.title)).join(","),
    ...rows.map((row) =>
      columns.map((column) => cell(column.value(row))).join(","),
    ),
  ].join("\n");
};

// Downloads rows as a .csv file (built in the browser).
export const downloadCsv = (filename, rows, columns) => {
  const blob = new Blob([toCsv(rows, columns)], {
    type: "text/csv;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
